import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OUTCOME_STYLE = {
  riuscito: "bg-green-100 text-green-700",
  bloccato: "bg-amber-100 text-amber-700",
  errore: "bg-red-100 text-red-700",
};

export const OrderAttemptsWidget = () => {
  const [open, setOpen] = useState(false);
  const [attempts, setAttempts] = useState(null);

  useEffect(() => {
    if (!open || attempts !== null) return;
    axios
      .get(`${API}/order-attempts?limit=30`)
      .then((r) => setAttempts(r.data || []))
      .catch(() => setAttempts([]));
  }, [open, attempts]);

  return (
    <div className="bg-white rounded-lg shadow p-4 mt-4" data-testid="order-attempts-widget">
      <button
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between text-left"
        data-testid="order-attempts-toggle"
      >
        <span className="font-semibold text-gray-900">🧾 Registro Tentativi Ordine</span>
        <span className="text-gray-400 text-sm">{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div className="mt-3">
          <p className="text-xs text-gray-500 mb-2">
            Ogni tentativo di ordine dal sito (bonifico, contanti, ecc.) con il suo esito.
            Utile quando un cliente dice "ho ordinato ma non risulta niente".
          </p>
          {attempts === null ? (
            <p className="text-sm text-gray-400">Caricamento…</p>
          ) : attempts.length === 0 ? (
            <p className="text-sm text-gray-400" data-testid="order-attempts-empty">
              Nessun tentativo registrato (il registro parte da questo aggiornamento)
            </p>
          ) : (
            <div className="space-y-1.5 max-h-80 overflow-y-auto">
              {attempts.map((a) => (
                <div
                  key={a.id}
                  className="flex flex-wrap items-center gap-2 border border-gray-200 rounded px-2.5 py-1.5 text-xs"
                  data-testid={`order-attempt-${a.id}`}
                >
                  <span className={`px-2 py-0.5 rounded-full font-semibold ${OUTCOME_STYLE[a.outcome] || "bg-gray-100 text-gray-600"}`}>
                    {a.outcome}
                  </span>
                  <span className="text-gray-500">
                    {a.at ? new Date(a.at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : ""}
                  </span>
                  <span className="font-medium text-gray-900">{a.customer_name || a.customer_email || "?"}</span>
                  {a.customer_email && a.customer_name && (
                    <span className="text-gray-500">{a.customer_email}</span>
                  )}
                  <span className="text-gray-500">{a.payment_method}</span>
                  {a.country && <span className="text-gray-500">🌍 {a.country}</span>}
                  {a.total_amount != null && <span className="text-gray-700 font-medium">€{Number(a.total_amount).toFixed(2)}</span>}
                  {a.order_id && <span className="text-green-700">#{a.order_id.slice(0, 8)}</span>}
                  {a.reason && (
                    <span className="w-full text-red-600" data-testid={`order-attempt-reason-${a.id}`}>
                      ↳ {a.reason}
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderAttemptsWidget;
